export default () => {};



// WEBPACK FOOTER //
// ./reducers/index.js